export default __webpack_public_path__ + "static/media/faq-illustration.ee37a19f.svg";